import React from "react";
import "./AlertConformationPopup.css";

const AlertConfirmationPopup = ({
  alert_image,
  alert_title1,
  alert_title2,
  btn1,
  btn2,
  onCancel,
  onAccept,
}) => {
  return (
    <>
      <div className="alert-conformation-popup">
        <div className="alert-conformation-popup-container">
          <div className="alert-conformation-popup-image">
            <img src={alert_image} alt="" />
          </div>
          <div style={{ marginBottom: "25px" }}>
            <h2>{alert_title1}</h2>
            <h4>{alert_title2}</h4>
          </div>
          <div className="alert-conformation-popup-btn-folder">
            <button type="button" className="cancel-btn" onClick={onCancel}>
              {btn1}
            </button>
            <button type="button" className="accept-btn" onClick={onAccept}>
              {btn2}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AlertConfirmationPopup;